import { createSharedStoreHook } from 'shared-store-hook';
export const handler = () => {};
export const useApi = createSharedStoreHook({
  initialState: {},
});
